// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c8-4";
export var closeButton = "_c8-6";
export var dismissButton = "_c8-3";
export var editImageWithAiContainer = "_c8-8";
export var imageUploadWrapper = "_c8-7";
export var misspelledWord = "_c8-5";
export var spellCheckContainer = "_c8-2";
export var spin = "_c8-1";
export var spinning = "_c8-0";